function ErrorNotFound() {
  return (
    <div className="page-content-wrapper">
      <div className="page-content">
        <div className="error-404 d-flex align-items-start justify-content-center">
          <div className="container">
            <div className="card radius-15 shadow-none">
              <div className="row g-0">
                <div className="col-lg-6">
                  <div className="card-body p-5">
                    <h1 className="display-1"><span className="text-primary">4</span><span className="text-danger">0</span><span className="text-success">4</span></h1>
                    <h2 className="font-weight-bold display-4">Access Notice</h2>
                    <p>No access to this feature.
                      <br />The page you requested could not be found.
                      <br />Please contact the Admin</p>
                    <div className="mt-5">
                      <a href="/admin/dashboard" className="btn btn-lg btn-primary px-md-5 radius-30">Go Home</a>
                      <a href="/admin/dashboard" className="btn btn-lg btn-outline-dark ms-3 px-md-5 radius-30">Back</a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <img src="../assets/images/errors-images/404-error.png" className="card-img" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ErrorNotFound